import { render, staticRenderFns } from "./OrderAll.vue?vue&type=template&id=07513ffa&scoped=true&"
import script from "./OrderAll.vue?vue&type=script&lang=js&"
export * from "./OrderAll.vue?vue&type=script&lang=js&"
import style0 from "./OrderAll.vue?vue&type=style&index=0&id=07513ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07513ffa",
  null
  
)

export default component.exports